import Vue from 'vue'
import state from 'lib/appState'

export default el => new Vue({
  el,
  data () {
    return {
      state
    }
  },
  computed: {
    getPdpLargeImage () {
      if (Object.keys(this.state.activeProduct).length) {
        return this.state.activeProduct.pdpLargeImage
      }
    }
  }
})
